import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { TOKEN_KEY } from "@/lib/api";
import { IdleWatcher } from "@/components/IdleWatcher";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
    } catch {
      setUser(null);
      setCompany(null);
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem(TOKEN_KEY)) await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  const login = async (token, u, c) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
    setCompany(c);
  };

  const logout = useCallback(async (reason) => {
    try { await api.post("/auth/logout", null, { skipAuthRedirect: true }); } catch { /* already expired */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
    setCompany(null);
    window.location.href = reason === "idle" ? "/login?expired=idle" : "/";
  }, []);

  const expireIdle = useCallback(() => { logout("idle"); }, [logout]);

  return (
    <AuthContext.Provider value={{ user, company, loading, login, logout, refresh, setCompany }}>
      {children}
      {user && <IdleWatcher onExpire={expireIdle} />}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
